import { useQuery } from "@tanstack/react-query";
import { getForm } from "@/lib/forms-api";
import { useOrgId } from "@/lib/org-context";

export function useForm(id: string | undefined) {
  const orgId = useOrgId();

  const { data, isLoading } = useQuery({
    queryKey: ["form", orgId, id],
    queryFn: () => getForm(id!),
    enabled: !!orgId && !!id,
  });

  return {
    form: data ?? null,
    loading: isLoading,
  };
}
